export class RateCurveProduct {
	rateId: number = 0;
	productId: number = 0;
}